import { getSangjoQuotations } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { HStack, queryKeys, useResponsive } from "goi_common";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import SlideBase from "react-slick";
import { useRecoilValue } from "recoil";
import { MatchRecommenationQuotationType } from "../../type/MatchRecommendationType";
import RecommendationCard from "./RecommendationCard";
import { SangjoNameLogo } from "./SangjoNameLogo";
import { StarScore } from "./StarScore";

const initialSlide = 0;

function RecommendationCardListCarousel() {
  const router = useRouter();
  const { isBiggerThanLg } = useResponsive();
  const [beforeCount, setBeforeCount] = useState<number>(initialSlide);
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const { data, isLoading } = useQuery(queryKeys.sangjoQuotation, () => getSangjoQuotations(), {
    enabled: isLoggedIn,
  });
  const results: Array<MatchRecommenationQuotationType> = useMemo(() => {
    if (!data || !isLoggedIn) {
      return [];
    } else if (!data.request) {
      return [];
    } else {
      return data.quotations;
    }
  }, [data]);
  // const CAPITAL_LIST = ["11", "31", "23"]; //서울, 경기, 인천

  // const hasMore = useMemo(() => {
  //   // 수도권인 경우에만
  //   if (data?.request && CAPITAL_LIST.includes(data?.request?.funeral_sido))
  //     return results.length > 0 && results.length < 3;
  //   return false;
  // }, [results, data]);
  const currentItem: MatchRecommenationQuotationType = useMemo(() => {
    return results[beforeCount];
  }, [results, beforeCount]);
  const handleCardClick = (id?: number) => {
    if (id) {
      router.push(`/match/recommendation/${id}`);
    }
  };
  return (
    <Box
      overflow="hidden"
      width="100%"
      paddingTop="28px"
      maxWidth={isBiggerThanLg ? "800px" : "480px"}
    >
      <Box mb="10px" padding={isBiggerThanLg ? `0 30px 0 400px` : "0 30px"} height="24px">
        <HStack alignItems="center" justifyContent="space-between">
          <SangjoNameLogo sangjo={currentItem?.sangjo} />
          <StarScore score={currentItem?.sangjo.average_score} />
        </HStack>
      </Box>
      {!isLoading && (
        <Slide
          dots={false}
          infinite={false}
          slidesToShow={1}
          centerMode
          initialSlide={initialSlide}
          centerPadding="26px"
          beforeChange={(_, next) => setBeforeCount(next)}
          arrows={false}
          autoplay={false}
        >
          {results?.length > 0 && (
            <RecommendationCard item={results[0]} handleCardClick={handleCardClick} />
          )}
          {!results || (results.length == 0 && <RecommendationCard isFirst />)}
          {/* {hasMore && <RecommendationCard hasMore quotationRequestId={data.request.id} />} */}
        </Slide>
      )}
    </Box>
  );
}

const Slide = styled(SlideBase)`
  .slick-arrow {
    display: none;
  }
  .slick-slide {
    padding: 0 8px;
  }
`;

export default RecommendationCardListCarousel;
